import React from "react";
import { Menu } from "native-base";

export class MenuGroup extends React.Component {
    render() {
        const { checkbox, radio, children, title, _title = {}, ...other } = this.props;
        const isOptionGroup = checkbox || radio
        const Component = isOptionGroup ? Menu.OptionGroup : Menu.Group
        return (
            React.createElement(Component, {
                ...other,
                children,
                _title: title ? _title : { ..._title, p: "0" },
                type: isOptionGroup ? checkbox ? "checkbox" : "radio" : undefined,
            })
        )
    }
}